import type { CalendarEvent, HomeworkAssignment } from "./types.js";

function categoryForEvent(event: CalendarEvent): HomeworkAssignment["category"] {
  return event.type === "homework" || event.type === "assessment" || event.type === "dictation"
    ? event.type
    : undefined;
}

function assignmentForEvent(event: CalendarEvent, previous?: HomeworkAssignment): HomeworkAssignment {
  return {
    ...previous,
    id: previous?.id || `calendar-assignment:${event.id}`,
    workspaceId: event.workspaceId,
    classId: event.classId!,
    calendarEventId: event.id,
    category: categoryForEvent(event),
    title: event.title,
    dueDate: event.date,
    note: event.note,
    createdAt: previous?.createdAt || event.createdAt,
    updatedAt: previous && previous.updatedAt > event.updatedAt ? previous.updatedAt : event.updatedAt,
  };
}

// Project legacy calendar entries too, without guessing links from titles or dates.
export function calendarAssignments(events: CalendarEvent[], saved: HomeworkAssignment[]): HomeworkAssignment[] {
  const assignments = saved.map((assignment) => {
    const event = events.find(
      (item) => item.id === assignment.calendarEventId && item.workspaceId === assignment.workspaceId && item.classId,
    );
    return event ? assignmentForEvent(event, assignment) : assignment;
  });
  for (const event of events) {
    if (!event.classId || !categoryForEvent(event)) continue;
    if (
      assignments.some(
        (assignment) => assignment.calendarEventId === event.id && assignment.workspaceId === event.workspaceId,
      )
    )
      continue;
    assignments.push(assignmentForEvent(event));
  }
  return assignments;
}

export function calendarEventForAssignment(assignment: HomeworkAssignment, previous?: CalendarEvent): CalendarEvent {
  return {
    ...previous,
    id: assignment.calendarEventId || `assignment-event:${assignment.id}`,
    workspaceId: assignment.workspaceId,
    classId: assignment.classId,
    title: assignment.title,
    date: assignment.dueDate,
    endDate: previous?.endDate && previous.endDate >= assignment.dueDate ? previous.endDate : undefined,
    type: assignment.category || "homework",
    note: assignment.note,
    allDay: previous?.allDay ?? true,
    timezone: previous?.timezone || "Asia/Hong_Kong",
    createdAt: previous?.createdAt || assignment.createdAt,
    updatedAt: assignment.updatedAt,
  };
}
